<template>
  <div>
    <v-app-bar
      dense
      flat
      height="50"
    >
      <v-row align="center">
        <v-col
          xs="12"
          sm="5"
          md="4"
          class="d-none d-sm-flex"
        >
          <search-field
            :search-text="searchText"
            :status="status"
            @statusChange="changeStatus"
            @search="onSearch"
          />            
        </v-col>
        <v-col
          xs="12"
          sm="7"
          md="8"
          align="end"
          class="d-none d-sm-flex justify-end align-center"
        >
          <v-btn
            color="primary"
            class="mr-3 elevation-0"
            @click="ExportPosAccountsList()"
          >
            <v-icon>mdi-cloud-download</v-icon>
          </v-btn>
          <SearchById @submit="openAccount" />

          <v-btn
            id="menu_item_refresh"
            color="primary"
            :loading="loader"
            class="mr-2 elevation-0"
            @click.native="reload()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <register
            :show-dialog.sync="register"
            @refresh="reload"
          />
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                id="account_add"
                slot="activator"
                :disabled="!$store.getters.checkUserPrivilege('ACC_REGISTER')"
                class="elevation-0"
                color="success"
                @click="newAccount()"
                v-on="on"
              >
                <v-icon>mdi-plus</v-icon> Account
              </v-btn>
            </template>
            <span>Register a new account.</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-card
      flat
      outlined
      tile
    >
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            class="d-flex d-sm-none"
          >
            <search-field
              :search-text="searchText"
              :status="status"
              @statusChange="changeStatus"
              @search="onSearch"
            />            
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-divider></v-divider>
        </v-row> -->
        <v-row>
          <v-col
            v-for="acc in accounts"
            :key="acc.id"
            cols="12"
            sm="4"
            md="3"
            xl="2"
            class="d-flex"
          >
            <v-card
              class="mx-auto"
              flat
              outlined
            >
              <v-card-text
                style="cursor: pointer"
                @click="openAccount(acc)"
              >
                <v-row justify="end">
                  <v-col cols="auto">
                    <account-options
                      :account="acc"
                      @reload="getAccounts()"
                    />
                  </v-col>
                </v-row>
                <v-row
                  class="text-center"
                  no-gutters
                >
                  <v-col
                    cols="12"
                    class="text-h5"
                  >
                    {{ acc.name }}
                  </v-col>
                  <v-col cols="12">
                    <v-icon small>
                      mdi-pound
                    </v-icon>
                    {{ acc.id }}
                  </v-col>
                  <v-col
                    cols="12"
                    class="subtitle-1"
                  >
                    <v-avatar
                      size="24"
                      class="mr-4"
                    >
                      <v-icon>mdi-bank</v-icon>
                    </v-avatar>
                    <span>Stores: {{ acc.stores }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                    class="subtitle-1"
                  >
                    Created @ {{ acc.createdAt }}
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider class="mt-2 mx-4" />

              <v-card-actions>
                <v-row justify="center">
                  <v-col cols="auto">
                    <v-chip
                      v-if="acc.activeStatus"
                      outlined
                      label
                      color="success--text"
                    >
                      Active
                    </v-chip>
                    <v-chip
                      v-else
                      outlined
                      label
                      color="error--text"
                    >
                      In-active
                    </v-chip>
                  </v-col>
                  <v-col cols="auto">
                    <v-chip
                      v-if="acc.verified"
                      outlined
                      label
                      color="success--text"
                    >
                      Verified
                    </v-chip>
                    <v-chip
                      v-else
                      outlined
                      label
                      color="error--text"
                    >
                      Not verified
                    </v-chip>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-show="totalPage > 1">
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="totalPage"
              :total-visible="7"
              @input="getAccounts()"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { failure, pagination } from "@/mixins/common";
import Register from "./Register";
import AccountOptions from "./AccountOptions";
import SearchField from "@/components/utils/SearchField";
import SearchById from "@/components/utils/SearchById";
import exportReport from "@/mixins/report";

export default {
	components: {
		Register,
		AccountOptions,
    SearchField,
    SearchById
	},
	mixins: [failure, pagination, exportReport],
	data() {
		return {
			loader: false,
			accounts: [],
      sortKey: "name",
      searchKey: "name",
			searchText: null,
			register: false,
			page: 1,
			totalPage: 0,
      status: "1"
		};
	},
	created() {
		this.init();
	},
	methods: {
		getAccounts() {
			this.loader = true;
			let url = `${this.ADMIN_API_URL}/accounts?page=${
				this.page - 1
			}&search_key=${this.searchKey}&sort_key=${this.sortKey}&limit=${this.limit}&status=${this.status}`;
			if (this.searchText) {
				url += `&search=${this.searchText}`;
			}
			this.$http.get(url).then(
				(res) => {
					this.accounts = res.body.data || [];
					this.totalPage = res.body.totalPage;
					this.page = res.body.pagination.page + 1;
					this.loader = false;
				},
				(failure) => {
					this.handleFailure(failure);
				}
			);
		},
		search() {
			this.page = 1;
			this.getAccounts();
		},
		reload() {
			this.searchText = null;
      this.status = "1";
			this.search();
		},
    onSearch(val) {
      this.searchText = val;
      if (!val || val.length >= 3) {
        this.search();
      }
    },
		changeStatus(status) {
			this.status = status;
			this.search();
		},
		openAccount({id}) {
			this.$router.push({
				name: "accountInfo",
				params: {
					accountId: id
				}
			});
		},
		newAccount() {
			this.register = true;
		},
		init() {
			this.$store.commit("setTitle", "Accounts");
			this.getAccounts();
		},
		clear() {
			this.errors = {};
			this.$refs.form.reset();
		},
    ExportPosAccountsList() {
      let url = `${this.ADMIN_API_URL}/export/accounts`;
      this.exportReport(url, ".csv", "Pos_Accounts_list");
    }
	}
};
</script>
